import {imagesSets} from "./imagesSets";

export const sets = [
    {
        id: 31,
        img: imagesSets.setGadjet,
        title: 'Сет Гаджет',
        structure: 'Ролл Йоко (белый соус), Ролл Киото (спайси соус), Ролл Мариока, Ролл Цыпа',
        price: '925',
        count: '32',
        weight: '1020',
    },
    {
        id: 32,
        img: imagesSets.origami,
        title: 'ОРИГАМИ',
        structure: 'РОЛЛЫ: ФИЛАДЕЛЬФИЯ КЛАССИК,ФИЛА ХОТ,ТАТАМИ,САЛАТ ЧУККА.',
        price: '825',
        count: '25',
        weight: '865',
    },
    {
        id:33 ,
        img: imagesSets.sushiHaus,
        title: 'СУШИ ХАУС',
        structure: 'ГУД 1/2, ГРИН 1/2, КАЛИФОРНИЯ КЛАССИК 1/2, КАЛИФОРНИЯ С ЛОСОСЕМ 1/2, МАРИОКА 1, АСО 1.',
        price: '925',
        count: '32',
        weight: '950',
    },
    {
        id: 34,
        img: imagesSets.setNaRadost,
        title: 'СЕТ НА РАДОСТЬ',
        structure: 'ЧИЗ ЛОСОСЬ 1, КАЛИФОРНИЯ С ЛОСОСЕМ 1, КАЛИФОРНИЯ КЛАССИК 1, МИСАТО 1',
        price: '1050',
        count: '32',
        weight: '865',
    },
    {
        id:35 ,
        img: imagesSets.setNaZavist,
        title: 'СЕТ НА ЗАВИСТЬ',
        structure: 'РЕД 1/2, КАЛИФОРНИЯ КЛАССИК 1/2, ИНЬ-ЯНЬ 1, СПАЙСИ ЛОСОСЬ 1, ЛОСОСЬ 1',
        price: '925',
        count: '26',
        weight: '870',
    },
    {
        id: 36,
        img: imagesSets.naDvoih,
        title: 'НА ДВОИХ',
        structure: 'РОЛЛЫ: КАЛИФОРНИЯ КЛАССИК 1, ГРИН 1/2, ГУД 1/2, ЛОСОСЬ 1, СУШИ: УГОРЬ 1, ОКУНЬ 1, ЛОСОСЬ 1.',
        price: '775',
        count: '25',
        weight: '620',
    },
    {
        id: 37,
        img: imagesSets.prazdnichnii,
        title: 'ПРАЗДНИЧНЫЙ',
        structure: 'РОЛЛЫ: ОКИНАВА-1, ГРИН-1, БАЛТИМОР-1, ТОРИ КУНСЕЙ-1, ФРЕШ-1, ГУД-1, ФИЛАДЕЛЬФИЯ КЛАССИК-1, СЛИВОЧНЫЙ-1, КАЛИФОРНИЯ С ЛОСОСЕМ-1',
        price: '2240',
        count: '72',
        weight: '1935',
    },
    {
        id:38 ,
        img: imagesSets.semeinii,
        title: 'СЕМЕЙНЫЙ',
        structure: 'РОЛЛЫ: ЧИЗ ЛОСОСЬ 1, КАЛИФОРНИЯ КЛАССИК 1, ГРИН 1/2, ЭПЛ 1, ОГУРЕЦ 1, ЛОСОСЬ 1, КРАБ 1, ОКУНЬ 1, ГУД 1/2. СУШИ: УГОРЬ 1, ОКУНЬ 1, ЛОСОСЬ 1, КРЕВЕТКА 1.',
        price: '1495',
        count: '60',
        weight: '1438',
    },
]